// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('jobSchedule', {
//         templateUrl: 'views/components/views/jobSchedule/jobSchedule.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'jobScheduleService', 'layoutService', function ($stateParams, stateService, utilityService, modalService, translateService, jobScheduleService, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let jobScheduleKeyno = $stateParams.jobschedule_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 bgJobScheduleMain: {
//                     selected: 'BASIS',
//                     buttons: [
//                         { id: 'BASIS', label: 'gb_jobschedule_main_basis', color: 'primary', onClick: () => vm.model.bgJobScheduleMain.selected = 'BASIS' },
//                         { id: 'PROC', label: 'gb_jobschedule_main_proc', color: 'primary', onClick: () => vm.model.bgJobScheduleMain.selected = 'PROC' },
//                         { id: 'STAT', label: 'gb_jobschedule_main_stat', color: 'primary', onClick: () => vm.model.bgJobScheduleMain.selected = 'STAT' }
//                     ]
//                 },
//                 edit: {},
//                 selectListRepeatEveryTypes: [],
//                 selectListRepeatEveryNumbers: [],
//                 addingToQueue: false,
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE CALLS

//             async function loadEdit() {
//                 const response = (await jobScheduleService.getEdit({ jobschedule_keyno: jobScheduleKeyno }))[0];

//                 vm.model.edit = response;

//                 vm.model.edit.execute_at_time = moment.utc(vm.model.edit.execute_at_time).local().format('YYYY-MM-DD HH:mm:ss');
//                 vm.model.edit.execute_from_time = moment.utc(vm.model.edit.execute_from_time).local().format('YYYY-MM-DD HH:mm:ss');
//                 vm.model.edit.execute_to_time = moment.utc(vm.model.edit.execute_to_time).local().format('YYYY-MM-DD HH:mm:ss');

//                 vm.model.edit.last_add_to_jobqueue_dt = moment.utc(vm.model.edit.last_add_to_jobqueue_dt).local().format('YYYY-MM-DD HH:mm:ss');
//                 vm.model.edit.last_processing_end_dt = moment.utc(vm.model.edit.last_processing_end_dt).local().format('YYYY-MM-DD HH:mm:ss');
//                 vm.model.edit.last_processing_start_dt = moment.utc(vm.model.edit.last_processing_start_dt).local().format('YYYY-MM-DD HH:mm:ss');
//                 vm.model.edit.next_run_datetime = moment.utc(vm.model.edit.next_run_datetime).local().format('YYYY-MM-DD HH:mm:ss');
//             }
            
//             async function loadRepeatEveryTypes() {
//                 vm.model.selectListRepeatEveryTypes = await jobScheduleService.listRepeatEveryTypes();
//             }
            
//             async function loadRepeatEveryNumbers() {
//                 if (utilityService.validateParmsValue(vm.model.edit.repeat_every_type) !== true) return;
                
//                 return vm.model.selectListRepeatEveryNumbers = await jobScheduleService.listRepeatEveryNumbers({ repeat_every_type: vm.model.edit.repeat_every_type });
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region BUTTON GROUP SINGLE FUNCTION

//             vm.selectBgJobScheduleMain = function (value) {
//                 vm.model.bgJobScheduleMain.selected = value;
//             }

//             // #endregion BUTTON GROUP SINGLE FUNCTION

//             // #region BUTTON ADD TO QUEUE FUNCTION

//             vm.addToQueueChanges = function () {
//                 vm.model.addingToQueue = true;

//                 let parms = {};
//                 parms = vm.model.edit;
//                 let dateToday = moment().format('YYYY-MM-DD');
//                 let executeAt = moment(dateToday + ' ' + parms.execute_at_time, 'YYYY-MM-DD HH:mm:ss');
//                 let executeFrom = moment(dateToday + ' ' + parms.execute_from_time, 'YYYY-MM-DD HH:mm:ss');
//                 let executeTo = moment(dateToday + ' ' + parms.execute_to_time, 'YYYY-MM-DD HH:mm:ss');

//                 if (executeTo.isSameOrBefore(executeFrom)) {
//                     executeTo.add(1, 'day');
//                 }

//                 parms.execute_at_time = executeAt.utc().format('YYYY-MM-DD HH:mm:ss');
//                 parms.execute_from_time = executeFrom.utc().format('YYYY-MM-DD HH:mm:ss');
//                 parms.execute_to_time = executeTo.utc().format('YYYY-MM-DD HH:mm:ss');

//                 jobScheduleService.saveObj(parms).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.addingToQueue = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         jobScheduleService.addToQueue(parms).then(function (response) {
//                             if (response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: function (dialogItself) {
//                                             dialogItself.close();
//                                             vm.model.addingToQueue = false;
//                                         }
//                                     }]
//                                 });
//                             } else {
//                                 vm.model.addingToQueue = false;
//                                 loadEdit();
//                             }
//                         });
//                     }
//                 });
//             }

//             // #endregion BUTTON ADD TO QUEUE FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 let parms = {};
//                 parms = vm.model.edit;
//                 let dateToday = moment().format('YYYY-MM-DD');
//                 let executeAt = moment(dateToday + ' ' + parms.execute_at_time, 'YYYY-MM-DD HH:mm:ss');
//                 let executeFrom = moment(dateToday + ' ' + parms.execute_from_time, 'YYYY-MM-DD HH:mm:ss');
//                 let executeTo = moment(dateToday + ' ' + parms.execute_to_time, 'YYYY-MM-DD HH:mm:ss');

//                 if (executeTo.isSameOrBefore(executeFrom)) {
//                     executeTo.add(1, 'day');
//                 }

//                 parms.execute_at_time = executeAt.utc().format('YYYY-MM-DD HH:mm:ss');
//                 parms.execute_from_time = executeFrom.utc().format('YYYY-MM-DD HH:mm:ss');
//                 parms.execute_to_time = executeTo.utc().format('YYYY-MM-DD HH:mm:ss');

//                 jobScheduleService.saveObj(parms).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'repeat_every_type':
//                         if (utilityService.validateWatchValue(value, vm.model.edit.repeat_every_type) !== true) return;

//                         vm.model.edit.repeat_every_type = value;

//                         if (utilityService.validateParmsValue(vm.model.edit.repeat_every_type) !== true) return;

//                         loadRepeatEveryNumbers();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadRepeatEveryTypes();
//                 loadRepeatEveryNumbers();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
